module.exports = __webpack_public_path__ + "static/media/splash-footer-stylish.de73115f.png";